import { render } from "./MenuSiProfile.vue?vue&type=template&id=8b9d324c&scoped=true"
import script from "./MenuSiProfile.vue?vue&type=script&lang=js"
export * from "./MenuSiProfile.vue?vue&type=script&lang=js"

import "./MenuSiProfile.vue?vue&type=style&index=0&id=8b9d324c&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b9d324c"]])

export default __exports__